import './DoubleColumnA.scss';

import { b2x } from '@b2x/react/src';
import classNames from 'classnames';

import { Container } from '../Container';

export interface DoubleColumnBContentType {
  asset?: b2x.contentTypes.AssetContentSectionV2;
  beforeAsset?: boolean;
  beforeAssetMobile?: boolean;
  copy?: {
    content?: string;
    title?: string;
  };
}

interface DoubleColumnBProps extends DoubleColumnBContentType {
  mainComponent?: boolean;
}

export const DoubleColumnB = ({ asset, beforeAsset, beforeAssetMobile, copy, mainComponent }: DoubleColumnBProps) => {
  return (
    <Container>
      <b2x.Div className={'double-column-b'} marginBottom={undefined}>
        <b2x.Div>
          <b2x.Row gap={{ lg: 5, xs: 0 }} justifyContent={'center'}>
            <b2x.Col
              className={classNames(
                'copy-column',
                beforeAssetMobile ? 'order-2' : 'order-1',
                beforeAsset ? 'order-lg-2' : 'order-lg-1'
              )}
              display={'flex'}
              size={{ lg: 5, xs: 12 }}
            >
              <b2x.Div
                alignItems={'center'}
                className="text-white"
                display={'flex'}
                paddingBottom={!beforeAssetMobile ? { lg: 0, xs: 4 } : 0}
                paddingTop={beforeAssetMobile ? { lg: 0, xs: 4 } : { lg: 0, xs: 5 }}
              >
                <b2x.Div
                  className={classNames(beforeAsset ? 'ps-lg-5' : 'pe-lg-5')}
                  display={'flex'}
                  flexDirection={'column'}
                  gap={{ lg: 3, xs: 2 }}
                >
                  <b2x.ConditionalWrapper
                    condition={copy?.title !== undefined}
                    wrapper={
                      mainComponent ? (
                        <b2x.H1 className="title" fontWeight={700} textAlign={{ md: 'start', xs: 'center' }} />
                      ) : (
                        <b2x.P className="title h1" fontWeight={700} textAlign={{ md: 'start', xs: 'center' }} />
                      )
                    }
                  >
                    {b2x.formatHtml(copy?.title)}
                  </b2x.ConditionalWrapper>
                  {copy?.content && (
                    <b2x.H4 className="content" style={{ fontWeight: 300 }}>
                      {b2x.formatHtml(copy.content)}
                    </b2x.H4>
                  )}
                </b2x.Div>
              </b2x.Div>
            </b2x.Col>
            <b2x.Col
              className={classNames(
                'asset-column px-lg-0',
                beforeAssetMobile ? 'order-1' : 'order-2',
                beforeAsset ? 'order-lg-1' : 'order-lg-2'
              )}
              size={{ lg: 5, xs: 12 }}
            >
              <b2x.AssetV2 {...asset} fluid />
            </b2x.Col>
          </b2x.Row>
        </b2x.Div>
      </b2x.Div>
    </Container>
  );
};
